import request from '@/utils/request'

// 创建用户账单
export function createOrder(data) {
  return request({
    url: '/yuzhen/order/create',
    method: 'post',
    data: data
  })
}

// 更新用户账单
export function updateOrder(data) {
  return request({
    url: '/yuzhen/order/update',
    method: 'put',
    data: data
  })
}

// 更新用户账单优惠券
export function updateOrderCoupon(data) {
  return request({
    url: '/yuzhen/order/update/coupon',
    method: 'put',
    data: data
  })
}

// 删除用户账单
export function deleteOrder(id) {
  return request({
    url: '/yuzhen/order/delete?id=' + id,
    method: 'delete'
  })
}

// 获得用户账单
export function getOrder(id) {
  return request({
    url: '/yuzhen/order/get?id=' + id,
    method: 'get'
  })
}

// 获得用户账单分页
export function getOrderPage(query) {
  return request({
    url: '/yuzhen/order/page',
    method: 'post',
    data: query
  })
}

// 获得用户账单
export function cancelOrder(id) {
  return request({
    url: '/yuzhen/order/cancel?id=' + id,
    method: 'get'
  })
}

// 创建用户账单
export function createPackageOrder(data) {
  return request({
    url: '/yuzhen/order/create/package',
    method: 'post',
    data: data
  })
}

// 创建充值账单
export function createTopUpOrder(data) {
  return request({
    url: '/yuzhen/order/create/topup',
    method: 'post',
    data: data
  })
}

// 创建视频播放账单
export function createVideoPlayingOrder(data) {
  return request({
    url: '/yuzhen/order/create/videoPlaying',
    method: 'post',
    data: data
  })
}

// 创建续费套餐账单
export function createPackageRenewOrder(data) {
  return request({
    url: '/yuzhen/order/create/renew',
    method: 'post',
    data: data
  })
}

// 创建客服预约服务费账单
export function createAppointmentReasonOrder(id) {
  return request({
    url: '/yuzhen/order/create/appointment?id=' + id,
    method: 'get',
  })
}

// 余额支付
export function userAccountPay(id) {
  return request({
    url: '/yuzhen/order/account/pay?id=' + id,
    method: 'get'
  })
}

// 与真coin支付
export function userAwardAccountPay(id) {
  return request({
    url: '/yuzhen/order/awardAccount/pay?id=' + id,
    method: 'get'
  })
}

// 导出用户账单 Excel
export function exportOrderExcel(query) {
  return request({
    url: '/yuzhen/order/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

// 提交支付订单
export function submitOrder(data) {
  return request({
    url: '/pay/order/submit',
    method: 'post',
    data: data
  })
}

// 获得支付订单
export function getPayOrder(id) {
  return request({
    url: '/yuzhen/order/get?id=' + id,
    method: 'get'
  })
}
